import React, { lazy, Suspense } from 'react';
import { Switch } from 'react-router-dom'
import { AppLayout, SimpleLayout } from '../../layouts';
import { EbPageLoader } from '../Common';


const ContactList = lazy(() => import('.').then((module) => ({ default: module.ContactList })));

const ContactRouter = (props) => {
    const AppRoute = props.AppRoute;
    return (
        <Switch>
            <Suspense fallback={<EbPageLoader />}>
                <AppRoute exact path="/contacts" layout={AppLayout} component={ContactList} pathkey="contact_list" />
            </Suspense>
        </Switch>
    )
}

export { ContactRouter };